import type { Notification } from '../Stores/NotificationStore'

/** Ендпойнт сповіщень поточного користувача. */
export const NOTIFICATIONS_URL = '/services/user/notifications'

/** Фільтр «лише непрочитані» у форматі колекцій ядра. */
export const UNREAD_FILTER = JSON.stringify({ and: [{ field: 'isReaded', op: '=', value: false }] })

/**
 * ⚠️ Кеш GET вимкнено в кожному запиті. Ядровий клієнт тримає відповідь
 * 30 секунд, і сповіщення, прочитане хвилину тому, при повторному відкритті
 * шухляди поверталося непрочитаним — зі старої відповіді.
 */
export const NO_CACHE = { isDisableResponseCache: true }

/**
 * Відповідь списку.
 *
 * Описана тут, а не взята з клієнта: ядровий `restClient.get` оголошений як
 * `KyResponse<unknown>`, хоча віддає вже розібраний JSON.
 */
export interface NotificationListResponse {
    items?: Notification[]
    meta?: { page: number; limit: number; total: number }
}
